// GENERATED FILE - DO NOT EDIT.
// Source: backend/tests/snapshots/openapi_contract.json, via `npm run gen:api` (orval).
// Regenerate after the API contract changes; `npm run check:gen-api` fails when this is stale.
import * as zod from 'zod';

export const RevisionOut = zod.object({
  "revision": zod.int()
});

export type RevisionOut = zod.input<typeof RevisionOut>;
export type RevisionOutOutput = zod.output<typeof RevisionOut>;
